import axios from 'axios';
import { OCTOPUS_BASE_URL } from '.';

export const getExpressSettings = (id: string) => (
    axios.get(`${OCTOPUS_BASE_URL}/business-settings/${id}/express-settings`)
);

export const updateExpressSettings = (id: string, payload: any) => (
    axios.put(`${OCTOPUS_BASE_URL}/business-settings/${id}/express-settings`, payload)
);
